export default __webpack_public_path__ + "static/hero-image-a851ea4d4a0cc592e7aae4a60298b679.png";